import reducer from './reducers';

export { default as mapOperations } from './operations';
export { default as mapTypes } from './types';

export default reducer;
